import type { ComponentProps, JSX, ReactNode, Ref } from 'react'

import { ArrowLeftIcon, IconButton, ScrollArea } from '@buffer-mono/popcorn'

import { TemplateDetails } from '~publish/components/TemplateDetails'

import { SidePanel } from '../SidePanel'

import styles from './TemplatesSidePanel.module.css'

export function TemplateDetailsView({
  template,
  onBack,
  backButtonRef,
  icon,
  actions,
  metadata,
}: {
  template: ComponentProps<typeof TemplateDetails>['template']
  onBack: () => void
  backButtonRef?: Ref<HTMLButtonElement>
  icon: ReactNode
  actions: ReactNode
  metadata?: ReactNode
}): JSX.Element {
  return (
    <TemplateDetails template={template}>
      <SidePanel.Header className={styles.templateDetailsHeader}>
        <IconButton
          ref={backButtonRef}
          label="Back to templates"
          variant="tertiary"
          onClick={onBack}
        >
          <ArrowLeftIcon />
        </IconButton>
        {icon}
      </SidePanel.Header>
      <SidePanel.Body asChild>
        <ScrollArea visibility="scroll" scrollbars="vertical">
          <div className={styles.bodyContent}>
            <TemplateDetails.Title size="sm" />
            <TemplateDetails.Description size="md" />
            <TemplateDetails.Body size="md">
              <TemplateDetails.Actions>{actions}</TemplateDetails.Actions>
            </TemplateDetails.Body>
            {metadata}
          </div>
        </ScrollArea>
      </SidePanel.Body>
    </TemplateDetails>
  )
}
